<mat-toolbar class="p-0 mat-elevation-z1">
  <mat-progress-bar *ngIf="showLoadingBar" class="loading-bar" color="accent" mode="indeterminate"></mat-progress-bar>

  <div fxFlex fxFill fxLayout="row" fxLayoutAlign="start center">
    <div fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">
      <div class="toolbar-separator"></div>

      <span id="txtCustomer" class="username mr-12 pl-3" style="min-width: 200px;"
        matTooltip="Customer">{{customerName}}</span>

      <div id="toolbarAccountCircle" fxLayout="row" fxLayoutAlign="start center" *ngIf="horizontalNav">
        <div class=" ml-16">
          <span class="material-icons md-36">account_circle</span>
        </div>
      </div>
    </div>

    <div class="" fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center">
      <div *ngIf="localModeActive===true" fxLayout="row" fxLayoutAlign="center center"
        style="min-width: 200px; padding-right: 16px; background-color: red; color:white; font-weight: bold;">
        <div fxLayout="column" fxLayoutAlign="left left">
          <span id="txtLocalModeActive" class="username mr-12 pl-3" style="font-family: sans-serif; text-align: center"
            matTooltip="Do not use Active Salon Cloud while Local Mode is active.">
            Warning: <br/>Local Mode Active
          </span>
        </div>
      </div>

      <div *ngIf="licenceExpiry" fxLayout="row" fxLayoutAlign="center center"
        style="min-width: 200px; padding-right: 16px">
        <div fxLayout="column" fxLayoutAlign="left left">
          <span id="txtLicenceExpiry" class="username mr-12 pl-3" style="font-family: sans-serif; text-align: center"
            matTooltip="LicenceExpiry">
            Licence Expiry:
            <span [ngStyle]="licenceExpiresWithin10Days && { color: '#f74a5e' }">
              {{ licenceExpiry | date : 'dd/MMM/YY' }}
            </span>
          </span>
        </div>
      </div>

      <div fxLayout="row" fxLayoutAlign="center center" *ngIf="showBranchSelection==false" style="min-width: 200px;">
        <span class="material-icons md-36">store</span>
        <div fxLayout="column" fxLayoutAlign="left left">
          <span id="txtBranch" class="username mr-12 pl-3" style="font-family: sans-serif; text-align: center;"
            matTooltip="Branch">{{ branch?.BranchNameEx}}</span>
          <span id="txtBranchTerminal" title="" matTooltip=""
            style="font-size:10px; margin-top:-6px; padding-left:10px;">{{terminalName}}</span>
        </div>
      </div>
      <!-- Branch Name Dropdown -->
      <div *ngIf="showBranchSelection==true" style="min-width: 200px;">
        <button id="btnBranch" mat-button [matMenuTriggerFor]="branchMenu" class="user-button px-16"
          matTooltip="Branch">
          <div fxLayout="row" fxLayoutAlign="center center">
            <span class="material-icons md-36">store</span>
            <div fxLayout="column" fxLayoutAlign="left left">
              <span id="txtBranch" class="username mr-12 pl-3" matTooltip="">{{ branch?.BranchNameEx
                }}</span>
              <span id="txtBranchTerminal" *ngIf="employee!=null" title="" matTooltip=""
                style="font-size:10px; padding-left:10px;">{{terminalName}}</span>
            </div>
            <i class="s-16 material-icons pr-16" fxHide.xs>keyboard_arrow_down</i>
          </div>
        </button>
        <mat-menu #branchMenu="matMenu" [overlapTrigger]="false">
          <button *ngFor="let b of branches" mat-menu-item (click)="selectBranch(b.BranchId)">
            <div style="display: flex; flex-direction: row;align-items: center;">
              <span>{{b.BranchNameEx}}</span>
            </div>
          </button>
        </mat-menu>
      </div>
      <!-- Employee Name and Dropdown -->
      <div *ngIf="employee!=null">
        <button id="btnMyAccount" mat-button [matMenuTriggerFor]="userMenu" class="user-button px-16"
          matTooltip="Employee" style="min-width: 200px;">
          <div fxLayout="row" fxLayoutAlign="center center">
            <span class="material-icons md-36">account_circle</span>
            <span id="txtUserName" class="username mr-12 pl-3" fxHide fxShow.gt-sm>{{ employee?.FullName }}
              <span *ngIf="((user$ |async)?.LogInAs || false)">(Sys)</span>
            </span>
            <i class="s-16 material-icons pr-16" fxHide.xs>keyboard_arrow_down</i>
          </div>
        </button>
        <!-- Employee Dropdown menu -->
        <mat-menu #userMenu="matMenu" [overlapTrigger]="false">
          <button id="btnUserProfile" mat-menu-item (click)="showUserProfile()">
            <div style="display: flex; flex-direction: row;align-items: center;">
              <span class="material-icons pr-2">account_circle</span>
              <span>My Profile</span>
            </div>
          </button>

          <button id="btnReturnToSys" class="mat-button mat-menu-item" mat-menu-item (click)="returnToSysDashboard();"
            *ngIf="((user$ |async)?.LogInAs || false)">
            <div style="display: flex; flex-direction: row;align-items: center;">
              <span class="material-icons pr-2">keyboard_return</span>
              <span>Return to System Dashboard</span>
            </div>
          </button>
        </mat-menu>
      </div>

      <!-- HWC Connected indicator -->
      <div class="toolbar-separator"></div>
      <button mat-button class="mat-button .hwcconnected-button" style="min-width: 64px;" [attr.matTooltip]="HWCHint"
        [matMenuTriggerFor]="hwcMenu">
        <span class="material-icons" [style.color]="HWCColor">
          gamepad
        </span>
      </button>

      <mat-menu #hwcMenu="matMenu" [overlapTrigger]="false">
        <button mat-menu-item (click)="HWCDashboard()">
          <div style="display: flex; flex-direction: row;align-items: center;">
            <span class="material-icons pr-2">dashboard</span>
            <span>HWC Dashboard</span>
          </div>
        </button>
        <button mat-menu-item (click)="resetHWC()">
          <div style="display: flex; flex-direction: row;align-items: center;">
            <span class="material-icons pr-2">restart_alt</span>
            <span>Reboot HWC</span>
          </div>
        </button>
      </mat-menu>

      <!-- Switch Employee Button -->
      <div class="toolbar-separator" *ngIf="employee!=null"></div>
      <button mat-button class="mat-button switchuser-button" #SwitchUserButton aria-label="Switch Employee"
        *ngIf="employee!=null" matTooltip="Switch User" (click)="SwitchUser()">
        <span class="material-icons">
          published_with_changes
        </span>
      </button>

    </div>
  </div>
</mat-toolbar>
<app-employee-profile #employeeProfile></app-employee-profile>